import React, { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import DownloadModal from "./Modals/DownloadModal";
import { useDispatch } from "react-redux";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
} from "../features/Products/ProductSlice";
import MegaMenu from "./MegaMenu";

function Menu({ setHoverMenu, hovermenu }) {
  const navigate = useNavigate();
  const [width, setWidth] = useState(window.innerWidth);
  const [show, setShow] = useState(false);
  const { t, i18n } = useTranslation();
  const isMobile = width <= 768;
  const dispatch = useDispatch();
  const BecomeSeller = async (id) => {
    if (isMobile) {
      window.location.assign("https://libas.page.link/welcome");
      //navigator("https://libas.page.link/cart");
    } else {
      setShow(true);
    }
  };
  function selectedPageNull() {
    dispatch(SetSizeFilter([]));
    dispatch(SetTopSizeFilter([]));
    dispatch(SetSelectdPage(0));
  }
  return (
    <>
      <div className=" show-modal-download">
        {show && <DownloadModal show={show} setShow={setShow} />}
      </div>

      {/* <div className="row mx-0 d-lg-none d-block">
              <div className="col-12 menu px-0"id="style-2">
                <div className="row-bg " >
                   < div className=" d-flex text-center justify-content-between link-text  mx-0 px-md-5 px-0 pt-md-4 pb-md-4 pt-2 pb-2"> 
                   <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}>
                          <div className="mainblog-menu2" >
                             <Link to="/products?topic=newdrops" className="link d-md-flex">{t("drops")}
                            
                             </Link>
                             </div>
                             </div>
                   <div className="mainblog-menu2"  onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}> 
                   <div className="mainblog-menu2" >
                   <Link to="/Brands" className="link d-md-flex">{t("Brands")}</Link>
                   </div>
                   </div>

                          
                          <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}>
                          <div className="mainblog-menu2" >
                            <Link  to={`/products?gender=${"WFA967se7qX0jYtySgTj"}`} className="link"> {t("Women")}</Link>
                            </div >
                            </div>
                            <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}>
                          <div className="mainblog-menu2" >
                          <Link  to={`/products?gender=${"KG3s4pPk3arcBux5ERnD"}`} className="link">{t("Men")} </Link>
                            </div>
                            </div>
                         
                          <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}>
                          <div className="mainblog-menu2" >
                            <Link to={`/products?id=${"AqFLulu9y2m4mqEIkch1"}`} className="link"> {t("Bags")} </Link>
                            </div>
                            </div>
                          <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}> 
                          <div className="mainblog-menu2" >

                       
                          <Link to={`/products?id=${"LVw0hUP9kEcd1Qr9CoEk"}`} className="link"> {t("Accessories")} </Link>
                          </div>
                          </div>
                          <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}>
                          <div className="mainblog-menu2" >
                            <Link to={`/products?id=${"WJmwaMSWxtl1dK1sPZ1x"}`}  className="link"> {t("Shoes")}</Link>
                            </div>
                            </div>
                          <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}>
                          <div className="mainblog-menu2" >
                            <Link to={`/all-blogs`}  className="link"> {t("footer46")}</Link>
                            </div>
                            </div>
                          <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}>
                            <div className="mainblog-menu2" >
                            <Link to={`/products?topic=Vintage`}  className="link"> {t("vintage")}</Link>
                            </div>
                            </div>

                          <div className="mainblog-menu2" onClick={()=>dispatch(SetSelectdPage(0))&selectedPageNull()}>
                            <div className=" mainblog-menu2 link" onClick={() => navigate('/all-blogs')}>{t("Become a Seller")}  </div>
                            </div>
                    </div>
    
                    </div>
                    
                  </div>
                  </div> */}
      <MegaMenu setHoverMenu={setHoverMenu} hovermenu={hovermenu} />
    </>
  );
}

export default Menu;
